// extracted by mini-css-extract-plugin
export default {"faqCard":"styles_faqCard__-DlrJ","cardHeader":"styles_cardHeader__Km4w4","btnToggler":"styles_btnToggler__kd4i+","cardBody":"styles_cardBody__qhCs+"};